import React from 'react';

import { Menu, MenuItem, Button } from '@material-ui/core';

import Link from './Link';
import { languages, languagesName } from '../locales';

const LangageSelector = () => {
  const [anchorEl, setAnchorEl] = React.useState(null);

  const handleClick = event => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <>
      <Button aria-controls="simple-menu" aria-haspopup="true" onClick={handleClick}>
        Langage
      </Button>
      <Menu
        id="language_selector"
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleClose}
      >
        {languages.map(language => (
          <MenuItem value={language} key={language}>
            <Link to={`/${language}`} hasLangPrefix>
              {languagesName[language]}
            </Link>
          </MenuItem>
        ))}
      </Menu>
    </>
  );
};

export default LangageSelector;
